import { PhaseType } from '@schema/phase'
import {
  InitiativeCreationStep,
  initiativeCreationSteps,
} from '../../shared/workflow'
import { CreationGuide } from '../blocks/CreationGuide'
import { useInitiativeAutoSave } from '../../shared/useInitiativeAutoSave'
import Column from '@app/components/layout/Column'
import type { InitiativeWithId } from '@app/pages/dashboard/initiative/shared/initiativeTypes'

import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { useEffect, useState } from 'react'

const CURRENT_STEP = initiativeCreationSteps.callSchedule
const FINISH_STEP = initiativeCreationSteps.finish

export const CallScheduleStep = ({
  initiative,
  selectedPhaseType,
  completeStep,
}: {
  initiative: InitiativeWithId
  selectedPhaseType: PhaseType
  completeStep: (step: InitiativeCreationStep) => void
}) => {
  const [callScheduled, setCallScheduled] = useState(
    initiative.isCalendlyScheduled,
  )
  const name = `${initiative.contactFirstName} ${initiative.contactLastName}`

  useInitiativeAutoSave(
    initiative.id,
    {
      isCalendlyScheduled: callScheduled,
      onboardingStep: callScheduled ? FINISH_STEP : CURRENT_STEP,
    },
    0,
  )

  useCalendlyEventListener({
    onEventScheduled: () => {
      completeStep(CURRENT_STEP)
      setCallScheduled(true)
    },
  })

  useEffect(() => {
    if (initiative.isCalendlyScheduled) {
      completeStep(CURRENT_STEP)
    }
  }, [initiative.isCalendlyScheduled, completeStep])

  return (
    <CreationGuide
      selectedPhaseType={selectedPhaseType}
      currentStep={CURRENT_STEP}
    >
      <Column gap="2.5rem" alignItems="stretch">
        <InlineWidget
          url="https://calendly.com/bela-crowdbuilding/gesprek-met-crowdbuilding"
          styles={{ height: '900px' }}
          prefill={{
            name: name,
            email: initiative.contactEmail,
          }}
        />
      </Column>
    </CreationGuide>
  )
}
